import React from 'react';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

import { Container } from './MarkdownContainer.style';

interface Props {
  content: string;
}

const MarkdownContainer: React.FC<Props> = ({ content }) => {
  return (
    <Container>
      <Markdown remarkPlugins={[remarkGfm, remarkBreaks]}>{content}</Markdown>
    </Container>
  );
};

export default MarkdownContainer;
